export default __webpack_public_path__ + "static/media/amenity-3.9000b738.jpg";